<template>
  <div class="title">
    "三秦好少年・红飘带 少年心"主题征文活动作品上传平台
  </div>
</template>
<script>
export default {
    name:"main_title"
}
</script>
<style scoped>
.title {
  display: block;
  font-size: 42px;
  font-weight: bold;
  color: #6E3621;
  line-height: 1.4;
  padding: 46px 0;
}
</style>